<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
        <breadcrumbs
            v-if="!qAdmin"
            :items="breadcrumbsItems"
        ></breadcrumbs>
        <breadcrumbs
            v-else
            :items="breadcrumbsItems1"
        ></breadcrumbs>
        <v-container fluid>
            <v-row>
                <v-col
                    cols="12"
                    md="12"
                    lg="3"
                    sm="12"
                >
                    <v-card
                        class="card-outter"
                        height="250px"
                        color="#4C787E"
                        dark
                        @click="setCounterDialog = true"
                    >
                        <v-card-text>Counter:</v-card-text>
                        <v-card-title
                            class="justify-center"
                            style="font-weight: bold;font-size: 50px;height: 100px; word-break: break-word;line-height: normal"
                        >
                            {{ counter ? counter : "No Counter" }}
                        </v-card-title>
                        <v-card-actions class="card-actions">
                            <v-btn
                                text
                                @click="setCounterDialog = true"
                            >Change
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    md="12"
                    lg="6"
                    sm="12"
                >
                    <v-card
                        class="card-outter"
                        :height="$vuetify.breakpoint.xs ? '320px' : '250px'"
                    >
                        <v-card-title class="justify-center headline">
                            {{ date }}
                        </v-card-title>
                        <v-container>
                            <v-row>
                                <v-col cols="6">
                                    <v-autocomplete
                                        :items="selections"
                                        label="Queue *"
                                        item-text="name"
                                        item-value="id"
                                        v-model="selectedQueue"
                                        outlined
                                        @change="getList"
                                        class="pb-0"
                                    >
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="6">
                                    <v-select
                                        :items="times"
                                        label="TimeSlot"
                                        v-model="selectedTime"
                                        outlined
                                        @change="getList()"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row justify="center" style="text-wrap: normal">
                                <v-switch v-model="waiting_card" class="mx-2" label="Appointment"></v-switch>
                                <v-switch v-model="arrived_card" class="mx-2" label="Arrived"></v-switch>
                                <v-switch v-model="serving_card" class="mx-2" label="Serving"></v-switch>
                                <v-switch v-model="close_card" class="mx-2" label="Served"></v-switch>
                                <v-switch v-model="cancel_card" class="mx-2" label="Cancel"></v-switch>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    md="12"
                    lg="3"
                    sm="12"
                >
                    <v-card
                        class="card-outter"
                        height="250px"
                        color="#C74C44"
                        dark
                        @click="missed()"
                    >
                        <v-card-title class="headline">Current Calling</v-card-title>
                        <v-card-title
                            class="justify-center"
                            style="font-weight: bold; font-size: 50px;height: 125px;"
                        >
                            {{ currentCallingNo }}
                        </v-card-title>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    v-if="waiting_card"
                    cols="12"
                    lg="6"
                    md="6"
                    sm="12"
                >
                    <v-card
                        class="overflow-y-auto"
                        max-height="400"
                    >
                        <v-banner
                            class="justify-center font-weight-bold"
                            sticky
                        >
                            <v-card-title class="pa-2">Appointment List</v-card-title>
                            <v-card-subtitle class="pb-0">
                                <v-icon x-small>people</v-icon>
                                {{ waitingPax }}
                            </v-card-subtitle>
                        </v-banner>
                        <v-list>
                            <v-list-item
                                two-line
                                v-for="wait in waiting"
                                :key="wait.id"
                            >
                                <v-list-item-content>
                                    <v-row
                                        no-gutters
                                    >
                                        <v-col cols="4" sm="4" xs="4">
                                            <v-list-item-title>{{ wait.name }}</v-list-item-title>
                                            <v-list-item-subtitle>Q No : {{ wait.queue_no }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ wait.phone_no }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ wait.email }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ wait.remarks }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>
                                                <v-icon x-small>people</v-icon>
                                                {{ wait.pax }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="3" sm="3" xs="3">
                                            <v-list-item-title>{{ itemTitle(wait.type) }}</v-list-item-title>
                                            <v-list-item-subtitle>{{
                                                    getTime(wait.appointment_date)
                                                }}
                                            </v-list-item-subtitle>
                                            <v-chip
                                                class="ma-0"
                                                color="primary"
                                                x-small
                                            >
                                                {{ getQName(wait.queue_id) }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-0"
                                                color="secondary"
                                                x-small
                                                v-if="wait.service_id"
                                            >
                                                {{ getServiceName(wait.service_id) }}
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="3" sm="3" xs="3">
                                            <v-list-item-title>Notify At</v-list-item-title>
                                            <v-list-item-subtitle>{{ getTime(wait.called_at) }}</v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2" style="text-align:right">
                                            <v-menu :absolute="true">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                        class="pr-4"
                                                        v-bind="attrs"
                                                        v-on="on">phone
                                                    </v-icon>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                        v-for="(call, index) in calls"
                                                        :key="index"
                                                        @click="calling(wait, call.title)"
                                                    >
                                                        <v-list-item-title>{{ call.title }}</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                            <v-menu :absolute="true">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs"
                                                            v-on="on">fa fa-ellipsis-v
                                                    </v-icon>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                        v-for="(action, index) in actions"
                                                        :key="index"
                                                        @click="updateStatus(wait, action.value)"
                                                        v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')"
                                                    >
                                                        <v-list-item-title
                                                            v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')">
                                                            {{ action.title }}
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-col>
                <v-col
                    v-if="arrived_card"
                    cols="12"
                    lg="6"
                    md="6"
                    sm="12"
                >
                    <v-card
                        class="overflow-y-auto"
                        max-height="400"
                    >
                        <v-banner
                            class="justify-center font-weight-bold"
                            sticky
                        >
                            <v-card-title class="pa-2">Arrived List</v-card-title>
                            <v-card-subtitle class="pb-0">
                                <v-icon x-small>people</v-icon>
                                {{ arrivedPax }}
                            </v-card-subtitle>
                        </v-banner>
                        <v-list>
                            <v-list-item
                                two-line
                                v-for="a in arrived"
                                :key="a.id"
                            >
                                <v-list-item-content>
                                    <v-row
                                        no-gutters
                                    >
                                        <v-col cols="4" sm="4" xs="4">
                                            <v-list-item-title>{{ a.name }}</v-list-item-title>
                                            <v-list-item-subtitle>Q No : {{ a.queue_no }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ a.phone_no }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ a.email }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ a.remarks }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>
                                                <v-icon x-small>people</v-icon>
                                                {{ a.pax }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>{{ itemTitle(a.type) }}</v-list-item-title>
                                            <v-list-item-subtitle>{{
                                                    getTime(a.appointment_date)
                                                }}
                                            </v-list-item-subtitle>
                                            <v-chip
                                                class="ma-0"
                                                color="primary"
                                                x-small
                                            >
                                                {{ getQName(a.queue_id) }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-0"
                                                color="secondary"
                                                x-small
                                                v-if="a.service_id"
                                            >
                                                {{ getServiceName(a.service_id) }}
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>Notify At</v-list-item-title>
                                            <v-list-item-subtitle>{{ getTime(a.called_at) }}</v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>Check-in</v-list-item-title>
                                            <v-list-item-subtitle>{{ getTime(a.check_in) }}</v-list-item-subtitle>
                                            <v-list-item-subtitle v-if="a.check_out">leave: {{
                                                    getTime(a.check_out)
                                                }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2" style="text-align:right">
                                            <v-menu :absolute="true">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                        class="pr-4"
                                                        v-bind="attrs"
                                                        v-on="on">phone
                                                    </v-icon>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                        v-for="(call, index) in calls"
                                                        :key="index"
                                                        @click="calling(a, call.title)"
                                                    >
                                                        <v-list-item-title>{{ call.title }}</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                            <v-menu :absolute="true">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs"
                                                            v-on="on">fa fa-ellipsis-v
                                                    </v-icon>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                        v-for="(action, index) in actions"
                                                        :key="index"
                                                        @click="updateStatus(a, action.value)"
                                                        v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')"
                                                    >
                                                        <v-list-item-title
                                                            v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')">
                                                            {{ action.title }}
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-col>
                <v-col
                    v-if="serving_card"
                    cols="12"
                    lg="6"
                    md="6"
                    sm="12"
                >
                    <v-card
                        class="overflow-y-auto"
                        max-height="400"
                    >
                        <v-banner
                            class="justify-center font-weight-bold"
                            sticky
                        >
                            <v-card-title class="pa-2">Serving List</v-card-title>
                            <v-card-subtitle class="pb-0">
                                <v-icon x-small>people</v-icon>
                                {{ servingPax }}
                            </v-card-subtitle>
                        </v-banner>
                        <v-list>
                            <v-list-item
                                two-line
                                v-for="s in serving"
                                :key="s.id"
                            >
                                <v-list-item-content>
                                    <v-row
                                        no-gutters
                                    >
                                        <v-col cols="4" sm="4" xs="4">
                                            <v-list-item-title>{{ s.name }}</v-list-item-title>
                                            <v-list-item-subtitle>Q No : {{ s.queue_no }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ s.phone_no }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ s.email }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ s.remarks }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>
                                                <v-icon x-small>people</v-icon>
                                                {{ s.pax }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>{{ itemTitle(s.type) }}</v-list-item-title>
                                            <v-list-item-subtitle>{{
                                                    getTime(s.appointment_date)
                                                }}
                                            </v-list-item-subtitle>
                                            <v-chip
                                                class="ma-0"
                                                color="primary"
                                                x-small
                                            >
                                                {{ getQName(s.queue_id) }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-0"
                                                color="secondary"
                                                x-small
                                                v-if="s.service_id"
                                            >
                                                {{ getServiceName(s.service_id) }}
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>Notify At</v-list-item-title>
                                            <v-list-item-subtitle>{{ getTime(s.called_at) }}</v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>Check-in</v-list-item-title>
                                            <v-list-item-subtitle>{{ getTime(s.check_in) }}</v-list-item-subtitle>
                                            <v-list-item-subtitle v-if="s.check_out">leave: {{
                                                    getTime(s.check_out)
                                                }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2" style="text-align:right">
                                            <v-menu :absolute="true">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                        class="pr-4"
                                                        v-bind="attrs"
                                                        v-on="on">phone
                                                    </v-icon>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                        v-for="(call, index) in calls"
                                                        :key="index"
                                                        @click="calling(s, call.title)"
                                                    >
                                                        <v-list-item-title>{{ call.title }}</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                            <v-menu :absolute="true">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs"
                                                            v-on="on">fa fa-ellipsis-v
                                                    </v-icon>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                        v-for="(action, index) in actions"
                                                        :key="index"
                                                        @click="updateStatus(s, action.value)"
                                                        v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')"
                                                    >
                                                        <v-list-item-title
                                                            v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')">
                                                            {{ action.title }}
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-col>
                <v-col
                    v-if="close_card"
                    cols="12"
                    lg="6"
                    md="6"
                    sm="12"
                >
                    <v-card
                        class="overflow-y-auto"
                        max-height="400"
                    >
                        <v-banner
                            class="justify-center font-weight-bold"
                            sticky
                        >
                            <v-card-title class="pa-2">Served List</v-card-title>
                            <v-card-subtitle class="pb-0">
                                <v-icon x-small>people</v-icon>
                                {{ closePax }}
                            </v-card-subtitle>
                        </v-banner>
                        <v-list>
                            <v-list-item
                                two-line
                                v-for="c in close"
                                :key="c.id"
                            >
                                <v-list-item-content>
                                    <v-row
                                        no-gutters
                                    >
                                        <v-col cols="4" sm="4" xs="4">
                                            <v-list-item-title>{{ c.name }}</v-list-item-title>
                                            <v-list-item-subtitle>Q No : {{ c.queue_no }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ c.phone_no }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ c.email }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ c.remarks }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>
                                                <v-icon x-small>people</v-icon>
                                                {{ c.pax }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>{{ itemTitle(c.type) }}</v-list-item-title>
                                            <v-list-item-subtitle>{{
                                                    getTime(c.appointment_date)
                                                }}
                                            </v-list-item-subtitle>
                                            <v-chip
                                                class="ma-0"
                                                color="primary"
                                                x-small
                                            >
                                                {{ getQName(c.queue_id) }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-0"
                                                color="secondary"
                                                x-small
                                                v-if="c.service_id"
                                            >
                                                {{ getServiceName(c.service_id) }}
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>Notify At</v-list-item-title>
                                            <v-list-item-subtitle>{{ getTime(c.called_at) }}</v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>Check-in</v-list-item-title>
                                            <v-list-item-subtitle>{{ getTime(c.check_in) }}</v-list-item-subtitle>
                                            <v-list-item-subtitle v-if="c.check_out">leave: {{
                                                    getTime(c.check_out)
                                                }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2" style="text-align:right">
                                            <v-menu :absolute="true">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                        class="pr-4"
                                                        v-bind="attrs"
                                                        v-on="on">phone
                                                    </v-icon>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                        v-for="(call, index) in calls"
                                                        :key="index"
                                                        @click="calling(c, call.title)"
                                                    >
                                                        <v-list-item-title>{{ call.title }}</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                            <v-menu :absolute="true">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs"
                                                            v-on="on">fa fa-ellipsis-v
                                                    </v-icon>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                        v-for="(action, index) in actions"
                                                        :key="index"
                                                        @click="updateStatus(c, action.value)"
                                                        v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')"
                                                    >
                                                        <v-list-item-title
                                                            v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')">
                                                            {{ action.title }}
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-col>
                <v-col
                    v-if="cancel_card"
                    cols="12"
                    lg="6"
                    md="6"
                    sm="12"
                >
                    <v-card
                        class="overflow-y-auto"
                        max-height="400"
                    >
                        <v-banner
                            class="justify-center font-weight-bold"
                            sticky
                        >
                            <v-card-title class="pa-2">Cancel List</v-card-title>
                            <v-card-subtitle class="pb-0">
                                <v-icon x-small>people</v-icon>
                                {{ cancelPax }}
                            </v-card-subtitle>
                        </v-banner>
                        <v-list>
                            <v-list-item
                                two-line
                                v-for="c2 in cancel"
                                :key="c2.id"
                            >
                                <v-list-item-content>
                                    <v-row
                                        no-gutters
                                    >
                                        <v-col cols="4" sm="4" xs="4">
                                            <v-list-item-title>{{ c2.name }}</v-list-item-title>
                                            <v-list-item-subtitle>Q No : {{ c2.queue_no }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ c2.phone_no }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ c2.email }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ c2.remarks }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>
                                                <v-icon x-small>people</v-icon>
                                                {{ c2.pax }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>{{ itemTitle(c2.type) }}</v-list-item-title>
                                            <v-list-item-subtitle>{{
                                                    getTime(c2.appointment_date)
                                                }}
                                            </v-list-item-subtitle>
                                            <v-chip
                                                class="ma-0"
                                                color="primary"
                                                x-small
                                            >
                                                {{ getQName(c2.queue_id) }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-0"
                                                color="secondary"
                                                x-small
                                                v-if="c2.service_id"
                                            >
                                                {{ getServiceName(c2.service_id) }}
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>Notify At</v-list-item-title>
                                            <v-list-item-subtitle>{{ getTime(c2.called_at) }}</v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>Check-in</v-list-item-title>
                                            <v-list-item-subtitle>{{ getTime(c2.check_in) }}</v-list-item-subtitle>
                                            <v-list-item-subtitle v-if="c2.check_out">leave: {{
                                                    getTime(c2.check_out)
                                                }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2" style="text-align:right">
                                            <v-menu :absolute="true">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                        class="pr-4"
                                                        v-bind="attrs"
                                                        v-on="on">phone
                                                    </v-icon>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                        v-for="(call, index) in calls"
                                                        :key="index"
                                                        @click="calling(c2, call.title)"
                                                    >
                                                        <v-list-item-title>{{ call.title }}</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                            <v-menu :absolute="true">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs"
                                                            v-on="on">fa fa-ellipsis-v
                                                    </v-icon>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                        v-for="(action, index) in actions"
                                                        :key="index"
                                                        @click="updateStatus(c2, action.value)"
                                                        v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')"
                                                    >
                                                        <v-list-item-title
                                                            v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')">
                                                            {{ action.title }}
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-col>
                <v-col
                    v-if="outlet.display_missed"
                    cols="12"
                    lg="6"
                    md="12"
                    sm="12"
                >
                    <v-card
                        class="overflow-y-auto"
                        max-height="400"
                    >
                        <v-banner
                            class="justify-center font-weight-bold"
                            sticky
                        >
                            <v-card-title class="pa-2">Missed List</v-card-title>
                            <v-card-subtitle class="pb-0">
                                <v-icon x-small>people</v-icon>
                                {{ missedPax }}
                            </v-card-subtitle>
                        </v-banner>
                        <v-list>
                            <v-list-item
                                two-line
                                v-for="mQ in missedQ"
                                :key="mQ.id"
                            >
                                <v-list-item-content>
                                    <v-row
                                        no-gutters
                                    >
                                        <v-col cols="4" sm="4" xs="4">
                                            <v-list-item-title>{{ mQ.name }}</v-list-item-title>
                                            <v-list-item-subtitle>Q No : {{ mQ.queue_no }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ mQ.phone_no }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ mQ.email }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ mQ.remarks }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>
                                                <v-icon x-small>people</v-icon>
                                                {{ mQ.pax }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>{{ itemTitle(mQ.type) }}</v-list-item-title>
                                            <v-list-item-subtitle>{{
                                                    getTime(mQ.appointment_date)
                                                }}
                                            </v-list-item-subtitle>
                                            <v-chip
                                                class="ma-0"
                                                color="primary"
                                                x-small
                                            >
                                                {{ getQName(mQ.queue_id) }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-0"
                                                color="secondary"
                                                x-small
                                                v-if="mQ.service_id"
                                            >
                                                {{ getServiceName(mQ.service_id) }}
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>Notify At</v-list-item-title>
                                            <v-list-item-subtitle>{{ getTime(mQ.called_at) }}</v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2">
                                            <v-list-item-title>Check-in</v-list-item-title>
                                            <v-list-item-subtitle>{{ getTime(mQ.check_in) }}</v-list-item-subtitle>
                                            <v-list-item-subtitle v-if="mQ.check_out">leave: {{
                                                    getTime(mQ.check_out)
                                                }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="2" sm="2" xs="2" style="text-align:right">
                                            <v-menu :absolute="true">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                        class="pr-4"
                                                        v-bind="attrs"
                                                        v-on="on">phone
                                                    </v-icon>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                        v-for="(call, index) in calls"
                                                        :key="index"
                                                        @click="calling(mQ, call.title)"
                                                    >
                                                        <v-list-item-title>{{ call.title }}</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                            <v-menu :absolute="true">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs"
                                                            v-on="on">fa fa-ellipsis-v
                                                    </v-icon>
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                        v-for="(action, index) in actions"
                                                        :key="index"
                                                        @click="updateStatus(mQ, action.value)"
                                                        v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')"
                                                    >
                                                        <v-list-item-title
                                                            v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')">
                                                            {{ action.title }}
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-col>
            </v-row>
            <v-dialog v-model="setCounterDialog">
                <v-card
                >
                    <v-card-title class="justify-center headline">Set Counter?</v-card-title>
                    <v-container>
                        <v-text-field
                            label="Counter"
                            v-model="counter"
                            placeholder="e.g.: Counter 1 / Room 1"
                        ></v-text-field>
                        <v-card-actions>
                            <v-btn color="success" @click="setCounter('yes')">Save</v-btn>
                            <v-btn @click="setCounter('no')">No Counter</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card>
            </v-dialog>
        </v-container>

      <v-row style="position: absolute; left: 20px; bottom: 20px;">
        <v-col>
          <v-dialog
              v-model="queueStatisticsDialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
              >
                Queue Statistics
              </v-btn>
            </template>
            <v-card>
              <v-toolbar
                  dark
                  color="primary"
              >
                <v-btn
                    icon
                    dark
                    @click="queueStatisticsDialog = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Queue Statistics</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-list
                  three-line
                  subheader
              >
<!--                <v-subheader></v-subheader>-->
                <v-list-item>
                  <v-list-item-content>
                    <date-input v-model="queueStatisticsDate" label="Queue Date"></date-input>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-btn @click="fetchQueueStatistics">Generate</v-btn>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-list
                  three-line
                  subheader
              >
<!--                <v-subheader>Detail</v-subheader>-->
                <v-list-item>
                  <v-list-item-content>
                    <v-row>
                      <v-col
                          cols="12"
                          lg="6"
                          md="6"
                          sm="6"
                          v-for="(queueStatistic,index) in queueStatistics"
                          :key="`queue-statistic-${index}`"
                      >
                        <v-card
                            class="overflow-y-auto"
                            max-height="400"
                        >
                          <v-banner
                              class="justify-center font-weight-bold"
                              sticky
                          >
                            <v-card-title class="pa-2">{{ queueStatistic.queue_name }}</v-card-title>
                          </v-banner>
                          <v-list>
                            <v-list-item
                                two-line
                            >
                              <v-list-item-content>
                                <v-row
                                    no-gutters
                                >
                                  <v-col>
                                    <v-list-item-title style="margin: 10px 0">Total Count: {{ getQueueTotalCountByQueueStatistic(queueStatistic).count }}&nbsp;&nbsp;&nbsp;&nbsp;Average waiting minutes: {{ queueStatistic.average_waiting_minutes }} {{ queueStatistic.average_waiting_minutes > 2 ? 'minutes' : 'minute' }}</v-list-item-title>
                                    <v-list-item-title style="margin: 10px 0">Served Count: {{ getQueueServedCountByQueueStatistic(queueStatistic).count }}&nbsp;&nbsp;&nbsp;&nbsp;Served Rate: {{ getQueueServedRateByQueueStatistic(queueStatistic) }}%</v-list-item-title>
                                    <v-list-item-title style="margin: 10px 0">Missed Count: {{ getQueueMissedCountByQueueStatistic(queueStatistic).count }}&nbsp;&nbsp;&nbsp;&nbsp;Missed Rate: {{ getQueueMissedRateByQueueStatistic(queueStatistic) }}%</v-list-item-title>
                                  </v-col>
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import moment from "moment";

export default {
    props: ['outlet', 'queues', 'services', 'userid', 'user'],
    data: () => ({
        waiting_card: true,
        arrived_card: true,
        serving_card: true,
        close_card: true,
        cancel_card: false,
        setCounterDialog: false,
        counter: null,
        counterSet: false,
        currentCallingNo: null,
        currentCallingQList: null,
        selectedQueue: null,
        selections: null,
        arrived: [],
        waiting: [],
        close: [],
        serving: [],
        cancel: [],
        missedQ: [],
        arrivedPax: 0,
        waitingPax: 0,
        closePax: 0,
        servingPax: 0,
        cancelPax: 0,
        missedPax: 0,
        actions: [
            {
                title: "Appointment",
                value: 'queue',
            },
            {
                title: 'Arrived',
                value: 'arrived',
            },
            {
                title: 'Serving',
                value: 'serving',
            },
            {
                title: 'Cancel',
                value: 'cancel',
            },
            {
                title: 'Served',
                value: 'served',
            },
            {
                title: 'Missed',
                value: 'missed'
            }
        ],
        times: [],
        selectedTime: null,
        breadcrumbsItems: '',
        breadcrumbsItems1: '',
        queueStatisticsDialog: false,
        queueStatisticsDate: null,
        queueStatisticsData: null,
    }),
    watch: {
        queueStatisticsDialog(value) {
          if (value) {
            this.fetchQueueStatistics(false)
          }
        }
    },
    computed: {
        calls() {
          if (this.outlet.id == 19) {
            return [
              {
                title: "WhatsApp",
              },
              {
                title: "TV",
              },
            ];
          }

          return [
            {
              title: "WhatsApp",
            },
            {
              title: "SMS",
            },
            {
              title: "TV",
            },
          ];
        },
        qAdmin() {
            let isAdmin = this.user.role_id === 5;
            let correctGroup = this.user.group_id === this.outlet.group_id;
            return isAdmin && correctGroup;
        },
      maxWidth() {
        return {
          maxWidth: window.outerWidth + 'px'
        }
      },
      queueStatistics () {
        return Array.isArray(this.queueStatisticsData)
            ? this.queueStatisticsData
            : []
      }
    },
    methods: {
        setCounter(val) {
            window.sessionStorage.setItem('setCounter', val);
            this.setCounterDialog = false;
            this.counterSet = true;
            if (val === 'yes') {
                window.sessionStorage.setItem('counter', this.counter)
            } else {
                window.sessionStorage.removeItem('counter');
                this.counter = '';
            }
        },

        updateStatus(qlist, status) {
            if (status === 'missed') {
                this.missed(qlist)
            } else {
                axios.post('/api/queueList/updateStatus', {
                    qlist_id: qlist.id,
                    status: status,
                    timeStamp: this.selectedTime,
                    user_id: this.userid
                }).then(response => {
                    this.getList()
                });
            }
        },
        getList() {
            if (!this.selectedQueue) {
                swal({
                    title: 'Please select queue!',
                    icon: "warning"
                })
            } else {
                axios.post('/api/getOutletQlists', {
                    oid: this.outlet.id,
                    qid: this.selectedQueue,
                    time: this.selectedTime,
                }).then(result => {
                    this.waiting = result.data.waiting;
                    this.waitingPax = result.data.waitingPax;
                    this.arrived = result.data.arrived;
                    this.arrivedPax = result.data.arrivedPax;
                    this.serving = result.data.serving;
                    this.servingPax = result.data.servingPax;
                    this.close = result.data.close;
                    this.closePax = result.data.closePax;
                    this.cancel = result.data.cancel;
                    this.cancelPax = result.data.cancelPax;
                    this.missedQ = result.data.missedQ;
                    this.missedPax = result.data.missedPax;
                });
            }
        },
        getTime(t) {
            if (t) return t.split(" ")[1];
        },
        async whatsapp(ql) {
            let msg = '';
            await this.formatMsg(ql).then(response => {
                msg = response;
            });

            window.open("https://web.whatsapp.com/send?phone=" + ql.phone_no + "&text=" + encodeURI(msg), "whatsapp");
            axios.post('/queue/' + ql.queue_id + '/list/' + ql.id + '?action=notify&type=whatsapp')
                .then(response => {
                    this.getList();
                });
        },
        async sms(ql) {
            let msg = '';
            await this.formatMsg(ql).then(response => {
                msg = response;
            });
            // send sms
            axios.post('/queue/' + ql.queue_id + '/list/' + ql.id + '?action=notify&type=sms', {
                msg: msg,
                to: ql.phone_no
            }).then(response => {
                this.getList();
            });
        },
        async formatMsg(ql) {
            let q = null;
            let displayQNo = false;
            let msg = '';

            await axios.post('/api/getQueue/', {
                qid: ql.queue_id
            }).then(response => {
                displayQNo = response.data.display_queue_no
                q = response.data
                msg = q.message
            })
            msg = msg !== '' && msg !== null ? msg : "Hi, it is your turn now";
            if (displayQNo) msg = '[Q No. ' + ql.queue_no + '] ' + msg;
            if (msg.includes('{name}')) {
                let name = ql.name ? ql.name : '';
                msg = msg.replaceAll('{name}', name);
            }
            return msg
        },
        calling(ql, type) {
            switch (type) {
                case "WhatsApp":
                    this.whatsapp(ql);
                    break;
                case "SMS":
                    this.sms(ql);
                    break;
                case "TV":
                    if (window.sessionStorage.getItem('setCounter') === null) {
                        swal({
                            title: 'Please set counter!',
                            icon: "warning"
                        })
                    } else {
                        this.currentCallingQList = ql;
                        this.tv(ql);
                    }
                    break;
            }
        },
        tv(ql, type = 'queue') {
            // to call with api action for Apple TV
            axios.post('/queue/' + ql.queue_id + '/list/' + ql.id + '?action=notify&type=tv&counter=' + window.sessionStorage.getItem('counter') + '&settype=' + type).then(response => {
                this.currentCallingNo = ql.queue_no;
                this.getList();
            });
        },
        getServiceName(s) {
            let serviceName = '';
            if (this.services.length > 0) {
                this.services.forEach(function (item, index) {
                    if (item.id === s) {
                        serviceName = item.name
                    }
                })
            }
            return serviceName
        },
        getQName(s) {
            let qName = '';
            if (this.queues.length > 0) {
                this.queues.forEach(function (item, index) {
                    if (item.id === s) {
                        qName = item.name
                    }
                })
            }
            return qName
        },
        itemTitle(type) {
            return type === 'onsite' ? 'Walk-in' : 'Appointment';
        },
        missed(qlist) {
            if (confirm("Put this number in missed list?")) {
                if (this.outlet.display_missed) {
                    this.tv(qlist, 'missed');
                }
                axios.post('/api/queueList/updateStatus', {
                    qlist_id: qlist.id,
                    status: 'missed',
                    timeStamp: this.selectedTime,
                    user_id: this.userid
                }).then(response => {
                    this.getList()
                });
            }
        },
        fetchQueueStatistics(loading = true) {
          axios.post('/api/queueStatistics', {
            oid: this.outlet.id,
            date: this.queueStatisticsDate
          }, {
            loading: loading
          }).then(response => {
            this.queueStatisticsData = response.data;
            console.log(this.queueStatisticsData)
          });
        },
        calculateQueueStatisticByStatus(queueStatistic, ...statusArray) {
          // STATUS_SERVING = 1;
          // STATUS_QUEUE = 2;
          // STATUS_SERVED = 3;
          // STATUS_CANCELLED = 4;
          // STATUS_ARRIVED = 5;
          // STATUS_MISSED = 6;
          const counts = queueStatistic.counts;

          let result = {count: 0, pax: 0};
          for (let i = 0; i < counts.length; i++) {
            const count = counts[i];
            if (statusArray.includes(count.status)) {
              result.count += counts[i].count;
              result.pax += counts[i].pax;
            }
          }

          return result;
        },
        getQueueTotalCountByQueueStatistic(queueStatistic) {
          return this.calculateQueueStatisticByStatus(queueStatistic, 1,2,3,4,5,6);
        },
        getQueueServedCountByQueueStatistic(queueStatistic) {
          return this.calculateQueueStatisticByStatus(queueStatistic, 1,3);
        },
        getQueueMissedCountByQueueStatistic(queueStatistic) {
          return this.calculateQueueStatisticByStatus(queueStatistic, 4,6);
        },
        getQueueServedRateByQueueStatistic(queueStatistic) {
          const totalCount = this.getQueueTotalCountByQueueStatistic(queueStatistic).count;
          if (totalCount === 0) {
            return 0;
          }
          return parseFloat(this.getQueueServedCountByQueueStatistic(queueStatistic).count / totalCount * 100).toFixed(2);
        },
        getQueueMissedRateByQueueStatistic(queueStatistic) {
          const totalCount = this.getQueueTotalCountByQueueStatistic(queueStatistic).count;
          if (totalCount === 0) {
            return 0;
          }
          return parseFloat(this.getQueueMissedCountByQueueStatistic(queueStatistic).count / totalCount * 100).toFixed(2);
        },
    },
    created() {
        Echo.channel('queue-monitor')
            .listen('.QueueMonitor', (e) => {
                if (e.outlet_id === this.outlet.id) this.getList()
            })

      this.queueStatisticsDate = moment().format('YYYY-MM-DD');
      // this.queueStatisticsDate = '2022-09-30';
    },
    beforeMount() {
        let newDate = new Date();
        let year = newDate.getFullYear();
        let month = (newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1);
        let day = newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate();
        this.date = year + '-' + month + '-' + day;
        let temp = [];
        temp.push({'text': 'All', 'value': 'all'});
        for (let i = 0; i < 24; i++) {
            let t = i;
            let t2 = i + 1;
            let h1, h2 = '';
            if (t < 10) {
                h1 = '0' + t + ':00';
            } else {
                h1 = t + ':00';
            }
            if (t2 < 10) {
                h2 = '0' + t2 + ':00';
            } else {
                h2 = t2 + ':00';
            }
            let timestamp1 = this.date + 'T' + h1 + ':00';
            let timestamp2 = this.date + 'T' + h2 + ':00';
            let timestamp = timestamp1 + ' ' + timestamp2;
            temp.push({'text': h1 + ' - ' + h2, 'value': timestamp});
        }
        this.times = temp;
        this.counter = window.sessionStorage.getItem('counter');
        this.counterSet = window.sessionStorage.getItem('setCounter') === 'yes';
        this.queues.unshift({id: 'all', name: 'All'});
        this.selections = this.queues;
        this.breadcrumbsItems = [
            {
                disabled: false,
                href: '/',
                link: true,
                text: 'Home',
            },
            {
                disabled: false,
                href: '/outlet/' + this.outlet.id + '/edit',
                link: true,
                text: this.outlet.name,
            },
            {
                disabled: true,
                href: '#',
                link: true,
                text: "Monitor Queues",
            },
        ];
        this.breadcrumbsItems1 = [
            {
                disabled: false,
                href: '/',
                link: true,
                text: 'Home',
            },
            {
                disabled: true,
                href: '#',
                link: true,
                text: "Monitor Queues",
            },
        ];
    },
    mounted() {
        this.counter = window.sessionStorage.getItem('counter');
        this.counterSet = window.sessionStorage.getItem('setCounter') === 'yes';
    }
}
</script>
<style>
.card-outter {
    position: relative;
    padding-bottom: 50px;
}

.card-actions {
    position: absolute;
    bottom: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Outlets/MonitorQueues.vue